import React, { useState } from 'react';
import LearningHub from '../../pages/LearningHub';
import LearningCourse from '../../pages/LearningCourse';
import OrgLearningDashboard from '../../pages/OrgLearningDashboard';

/**
 * Keeps the whole Learning Hub inside the platform shell — the left menu never
 * disappears, because every screen change is state, not a route change.
 */
export const LearningHubRouter = ({ initialCourseId = null }) => {
  const [screen, setScreen] = useState(initialCourseId ? 'course' : 'home');
  const [courseId, setCourseId] = useState(initialCourseId);
  const [hubTab, setHubTab] = useState('home');

  const openCourse = (course) => {
    setCourseId(course.course_id);
    setScreen('course');
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  const goHome = (tab = 'home') => {
    setHubTab(tab);
    setScreen('home');
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  if (screen === 'course' && courseId) {
    return (
      <LearningCourse
        courseId={courseId}
        onBackToHub={() => goHome('home')}
        onMyLearning={() => goHome('mine')}
      />
    );
  }

  if (screen === 'org') {
    return <OrgLearningDashboard onBack={() => goHome('home')} />;
  }

  return (
    <LearningHub
      tab={hubTab}
      onTabChange={setHubTab}
      onOpenCourse={openCourse}
      onOpenOrgDashboard={() => { setScreen('org'); window.scrollTo({ top: 0 }); }}
    />
  );
};

export default LearningHubRouter;
